"use client"

import Autoplay from "embla-carousel-autoplay"
import { Star } from "lucide-react"
import Image from "next/image"
import { useEffect, useState } from "react"

import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "@/components/ui/carousel"

import HeaderSection from "../header-section"
import { Skeleton } from "../ui/skeleton"

type Review = {
  author_name: string;
  rating: number;
  text: string;
  relative_time_description: string;
  profile_photo_url: string;
  time: number;
};

type Reviews = {
  reviews: Review[];
  rating: number | null;
  total: number;
}

const TestimonialsSection = () => {

  const [api, setApi] = useState<CarouselApi>()
  const [current, setCurrent] = useState(0)
  
  const [testimonials, setTestimonials] = useState<Reviews>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetch("/api/google-reviews")
      .then(res => res.json())
      .then(data => setTestimonials(data))
      .finally(() => setLoading(false));
  }, []);

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`h-4 w-4 ${
          index < rating 
            ? "fill-yellow-400 text-yellow-400" 
            : "fill-muted text-muted"
        }`}
      />
    ));
  };

  useEffect(() => {
    if (!api) {
      return
    }
 
    setCurrent(api.selectedScrollSnap() + 1)
 
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1)
    })
  }, [api])

function normalizeReviewText(text: string) {
  if (!text) return text
  const lower = text.toLowerCase()
  return lower.charAt(0).toUpperCase() + lower.slice(1)
}

  return (
<section id="depoimentos" className="relative py-20 scroll-mt-26 overflow-hidden bg-[url('/teste.jpg')] md:bg-no-repeat bg-center bg-contain md:bg-cover md:m-4 md:rounded-lg">

  <div className="absolute inset-0 bg-[#498BAB]/95 z-0"></div>

      <div className="relative max-w-7xl mx-auto px-6 z-10">
        <div className=" gap-12 lg:gap-16 items-start">
          <div className="flex justify-center z-20">
            <HeaderSection
              title="Depoimentos"
              description="Descubra histórias reais de tutores que confiaram em nós com seus pets e saíram mais felizes do que nunca."
              direction="center"
              opositeColor={true}
            />             
          </div>

          {/* Right Column - Testimonials Carousel */}
          <div className="space-y-6 max-w-4xl mx-auto mt-8">
            <Carousel
              setApi={setApi}
              className="w-full" 
              opts={{ align: "start", loop: true,  }}
              plugins={[
                Autoplay({
                  delay: 5000,
                }),
              ]}
            >
              <CarouselContent className="-ml-4">

                {loading && (
                  <CarouselItem className=""> 
                   <Skeleton className="h-[250px] w-full rounded-lg" />
                  </CarouselItem>
                )}

                {testimonials?.reviews?.map((review, index) => (
                  <CarouselItem key={index} className="pl-4 relative h-auto">
                    <div className="relative bg-[#FFF6F2] rounded-3xl px-0 py-10 md:p-8 lg:p-10 w-full testimonials-card">
                    
                      <div className="absolute top-6 left-6 text-7xl font-serif leading-none text-[#F2A07C]">“</div>

                      <p className="text-muted-foreground font-light md:text-lg leading-relaxed italic text-center text-balance px-4 py-6">
                        {normalizeReviewText(review.text)}
                      </p>

                      <div className="absolute -bottom-2 right-6 text-7xl text-[#F2A07C] font-serif leading-none">”</div>
                    </div>
                    <div className="flex flex-col items-center gap-1 mt-10">
                      <Image
                        src={review.profile_photo_url}
                        alt={review.author_name}
                        className="h-16 w-16 rounded-full object-cover"
                        width={100}
                        height={100}
                      />
                      <p className="font-bold text-white mt-2 lowercase">{review.author_name}</p>
                      <div className="flex gap-1 mb-1">
                        {renderStars(review.rating)}
                      </div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
               
               <div className="flex justify-center mt-6 gap-2 md:gap-3">
                {testimonials?.reviews?.map((_, index) => (
                  <button
                    key={index}
                    aria-label="mark slider"
                    onClick={() => api?.scrollTo(index)}
                    className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-200 ${
                      index === current - 1 ? "bg-secondary ring-1 ring-offset-2 ring-secondary" : "bg-slate-300 "
                    }`}
                  />
                ))}
              </div>
            </Carousel>
          </div>
              
          

        </div>
       
      </div>
       {/* <div className="bg-secondary mx-6 rounded-lg mt-20">
        <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 p-8 py-16">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">{stat.value}</div>
                <p className="text-sm text-white">{stat.label}</p>
              </div>
            ))}
          </div>
          </div>
        </div> */}
    </section>
  )
}

export default TestimonialsSection